import { makeObservable, observable, action } from "mobx";
import { PricingState, waiting, loading, ready, PricingPayload } from "./Types";

export type QuotationParams = {
  [key: string]: string | number | boolean;
};

class PricingStore {
  pricingState: PricingState;
  quotationParams: QuotationParams;

  constructor() {
    this.pricingState = waiting();
    this.quotationParams = {};
    makeObservable(this, {
      pricingState: observable,
      quotationParams: observable,
      loading: action,
      ready: action,
      setQuotationParams: action
    });
  }

  loading = () => {
    this.pricingState = loading();
  };

  ready = (pricing: PricingPayload) => {
    this.pricingState = ready(pricing);
  };

  setQuotationParams = (quotationParams: QuotationParams) => {
    this.quotationParams = quotationParams;
  };
}

export default PricingStore;
